import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import Bank from "../../entities/Bank";
import i18n from "../../i18n";
import { apiCallBegan } from "../api";
import { AppDispatch, AppState } from "../configureStore";
import ResponseBase from "../types/ResponseBase";
import SliceCollectionBase from "../types/SliceCollectionBase";
import { authHeader } from "../users/auth";
import Currency from "entities/Currency";

// RESPONSE DECLARATIONS //
interface RemoteWorkTypeResponse extends ResponseBase {
  Code: string;
  Name: string;
}

type ClassificatorResponse<T> = T[] | { value: T[] };

// SLICE //
interface State extends SliceCollectionBase<Bank> { }

const initialState: State = {
  list: [],
  loading: false,
  lastFetch: null,
  error: null
}

const slice = createSlice({
  name: "remoteWorkTypes",
  initialState,
  reducers: {

    remoteWorkTypesRequested: (remoteWorkTypes) => {
      remoteWorkTypes.loading = true;
      remoteWorkTypes.error = null;
    },
    remoteWorkTypesReceived: (remoteWorkTypes, action: PayloadAction<ClassificatorResponse<RemoteWorkTypeResponse>>) => {
      remoteWorkTypes.list = schema(unwrapClassificatorResponse(action.payload));
      remoteWorkTypes.loading = false;
      remoteWorkTypes.lastFetch = Date.now();
    },
    remoteWorkTypesRequestFailed: (remoteWorkTypes, action) => {
      remoteWorkTypes.loading = false;
      remoteWorkTypes.error = action.payload;
    }
  }
});

const {
  remoteWorkTypesRequested,
  remoteWorkTypesReceived,
  remoteWorkTypesRequestFailed
} = slice.actions;

export default slice.reducer;

// ACTION CREATORS //
export const getRemoteWorkTypes = () => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (getState().entities.remoteWorkTypes.loading) {
    return;
  }


  const url = `/api/classificator/remote-work-types`;

  var result =  await dispatch(
    apiCallBegan({
      url,
      method: "GET",
      headers: { ...authHeader(), "Accept-Language": i18n.language },
      onStart: remoteWorkTypesRequested.type,
      onSuccess: remoteWorkTypesReceived.type,
      onError: remoteWorkTypesRequestFailed.type
    })
  );
  return result
}

// NORMALIZATION //
const schema = (payload: RemoteWorkTypeResponse[]): Bank[] => {
  if (!payload || payload.length === 0) {
    return [];
  }

  return payload.map((resp: RemoteWorkTypeResponse): Currency => (
    {
      Code: resp.Code,
      Id: resp.Id,
      Name: resp.Name
    }
  ))
};

const unwrapClassificatorResponse = <T>(payload: ClassificatorResponse<T>): T[] => {
  if (Array.isArray(payload)) {
    return payload;
  }

  return payload?.value || [];
};
